
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import PropositionOptionForm from '@/components/forms/PropositionOptionForm.vue'
import VueScrollTo from 'vue-scrollto'

const configModule = namespace('config')

@Component({
  components: {
    BaseCardContainer,
    PropositionOptionForm
  }
})
export default class BlocTextUpdate extends Vue {
  @configModule.Action('getPropositionOptionByIdAction') getPropositionOptionById: any
  @configModule.Action('getPropositionOptionsAction') getPropositionOptions: any
  @configModule.Action('updatePropositionOptionAction') updatePropositionOption: any
  @configModule.Getter('propositionOptionGetter') propositionOption: any

  mounted() {
    this.getPropositionOptionById(this.$route.params.id)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.id', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getPropositionOptionById(newVal)
  }

  onSubmit(data: any) {
    this.updatePropositionOption({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getPropositionOptions()
      this.$router.push({name: 'OptionList'})
    })
  }

  onCancel() {
    this.$router.push({name: 'OptionList'})
  }
}
